import { registerLocaleData } from '@angular/common';
import { enableProdMode } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { bootstrapApplication } from '@angular/platform-browser';
import { getDateFnsLocale, Logger, supportedLocales, SupportedLocales } from '@crt/sui';
import { setDefaultOptions } from 'date-fns';

import { appConfig } from '@app/app.config';
import { AppConstants } from '@app/app.constants.service';

import { environment } from './environments/environment';

import 'ag-grid-enterprise';

if (environment.production) {
  enableProdMode();
}

// Read locale from local storage before app initialization
const appLang = getAppLang();

// Init provided language
initLanguage(appLang)
  // Only load text after locale is initialized to translate static file
  .then(() => import('@app/app.component'))
  .then(({ AppComponent }) =>
    bootstrapApplication(AppComponent, appConfig(appLang)).catch((err) =>
      Logger.error('Error initing app language', { data: err }),
    ),
  );

function getAppLang(): SupportedLocales {
  const lang = supportedLocales.parse(
    localStorage.getItem(`${AppConstants.PERSISTENT_PREFIX}locale`) ||
      navigator.language.split('-')[0],
  );

  return lang;
}

async function loadLocaleData(locale: SupportedLocales): Promise<void> {
  let localeModule;
  switch (locale) {
    case 'ja':
      localeModule = await import('@angular/common/locales/ja');
      break;
    default:
      localeModule = await import('@angular/common/locales/en');
  }
  registerLocaleData(localeModule.default);
}

async function initLanguage(locale: SupportedLocales): Promise<void> {
  // Fetch XLIFF translation file and transform to JSON format (JSON translations can be used directly)
  const json = await fetch(
    locale === 'en' ? environment.localeFiles.en : environment.localeFiles.ja,
  ).then((r) => r.json());

  // Initialize translation
  loadTranslations(json.translations);
  $localize.locale = locale;

  setDefaultOptions({ locale: getDateFnsLocale(locale) });

  // Load required locale module (needs to be adjusted for different locales)
  loadLocaleData(locale);
}
